module.exports = __webpack_public_path__ + "img/arrow-right.e42664b9.svg";